import React, { useEffect, useState } from "react";
import { makeStyles } from "@material-ui/core";
import styles from "assets/jss/material-dashboard-pro-react/views/formsStyle.js";
import PropTypes from "prop-types";
import { Redirect, useParams } from "react-router-dom";
import GridContainer from "components/Grid/GridContainer";
import GridItem from "components/Grid/GridItem";
import Card from "components/Card/Card";
import CardHeader from "components/Card/CardHeader";
import CardIcon from "components/Card/CardIcon";
import { MailOutline } from "@material-ui/icons";
import CardBody from "components/Card/CardBody";
import Button from "components/CustomButtons/Button.js";
import CustomInput from "components/CustomInput/CustomInput";
import { masterApi } from "functions/apis";

const useStyles = makeStyles(styles);

const defaultValue = {
  code: "",
  name: ""
};

export function DeletePort(props) {
  const classes = useStyles();

  const deletePortSignal = React.useRef(new AbortController());
  const { id } = useParams();

  const [payload, setPayload] = useState(defaultValue);
  const [disabled, setDisabled] = useState(false);
  const [redirect, setRedirect] = useState(false);

  useEffect(() => {
    return () => deletePortSignal.current.abort();
  }, []);

  useEffect(() => {
    if (id) {
      masterApi
        .get("Ports/" + id, {
          signal: deletePortSignal.current.signal
        })
        .then(resp =>
          setPayload({
            code: resp.code,
            name: resp.name
          })
        );
    }
  }, [id]);

  const handleDelete = e => {
    e.preventDefault();
    setDisabled(true);

    masterApi
      .delete("Ports/" + id, {
        signal: deletePortSignal.current.signal
      })
      .then(() => setRedirect(true))
      .catch(error => {
        console.log(error);
        setDisabled(false);
      });
  };

  return redirect ? (
    <Redirect to={"/admin/Port/InDraft"} />
  ) : (
    <GridContainer>
      <GridItem xs={12}>
        <Card>
          <CardHeader color="rose" icon>
            <CardIcon color="rose">
              <MailOutline />
            </CardIcon>
            <h4 className={classes.cardIconTitle}>DELETE PORT</h4>
          </CardHeader>
          <CardBody>
            <p>Are you sure want to delete this port?</p>

            <form onSubmit={handleDelete}>
              <Button onClick={() => props.history.goBack()} value="Back">
                BACK
              </Button>
              <Button
                disabled={disabled}
                color="rose"
                type="submit"
                value="Submit"
              >
                DELETE
              </Button>
            </form>

            <GridContainer>
              <GridItem xs={6}>
                <CustomInput
                  labelText="Code"
                  formControlProps={{
                    fullWidth: true
                  }}
                  inputProps={{
                    value: payload.code ?? "",
                    disabled: true
                  }}
                />
              </GridItem>
              <GridItem xs={6}>
                <CustomInput
                  labelText="Name"
                  formControlProps={{
                    fullWidth: true
                  }}
                  inputProps={{
                    value: payload.name ?? "",
                    disabled: true
                  }}
                />
              </GridItem>
            </GridContainer>
          </CardBody>
        </Card>
      </GridItem>
    </GridContainer>
  );
}

DeletePort.propTypes = {
  history: PropTypes.object
};
